import React from "react";
import styled from "styled-components";

import BottomBar from "./BottomBar/BottomBar";
import Footer from "./Footer/Footer";
import ScrollIndicator from "./utils/ScrollIndicator";
import Logo from "../assets/images/senka.png";

const MainContainer = ({
  children,
  offCenter,
  offPadding,
  hideLogo,
  setActiveCategory,
}) => {
  return (
    <Container>
      <ScrollIndicator />
      <BottomBar />
      <Content $offCenter={offCenter} $offPadding={offPadding}>
        {!hideLogo && <AbsoluteLogo src={Logo} />}

        {children}
      </Content>
      <Footer setActiveCategory={setActiveCategory} />
    </Container>
  );
};

export default MainContainer;

const Container = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  min-height: 100svh;
  background: var(--bg0);

  width: 100%;
`;

const Content = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: ${(props) => (props.$offCenter ? "flex-start" : "center")};
  height: 100%;
  justify-content: center;
  padding-bottom: ${(props) => (props.$offPadding ? "0rem" : "14rem")};
  padding-top: ${(props) => (props.$offPadding ? "0rem" : "4rem")};
`;

const AbsoluteLogo = styled.img`
  position: fixed;
  right: 1rem;
  height: auto;
  width: 40vh;
  pointer-events: none;
  user-select: none;
  bottom: 1rem;
  @media (max-width: 768px) {
    display: none;
  }
`;
